import axios from '@/libs/http'

export const listClerkGift = () => {
    return axios.request({
        url: '/s/c/gift/listClerkGift',
        method: 'get'
    })
}
export const updateHideGift = (giftId, isHide) => {
    let data = new URLSearchParams()
    data.append('giftId', giftId)
    data.append('isHide', isHide)
    return axios.request({
        url: '/s/c/gift/updateHideGift',
        data,
        method: 'post'
    })
}
